<template>
    <ModalBase
        :name="name"
        title="Descargar abonados"
        @close="() => close()"
    >
        <template>            
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <Button @click="getAbonados()">DESCARGAR</Button>
                    </div>
                </div>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref } from 'vue'
    import store from '@/store'
    import { useToast } from '@/composables/common/useToast'
    import { config } from '@/config'
    import ModalBase from '@/modules/admin/ui/ModalBase'

    const props = defineProps({
        name: String,
        searchParams: Object
    })

    const emit = defineEmits(['close'])
    const toast = useToast()

    const loading = ref(false)

    const close = () => {
        emit('close', props.name)
    }

    const getAbonados = () => {
        loading.value = true

        const params = {
            ...props.searchParams,
            filters: { ...props.searchParams.filters }
        }
        delete params.filters.per_page
        delete params.filters.page

        store.dispatch(config.getVuexAlias('back.abonados.abonos.descargar_excel'), params)
            .then(res => {
                toast.success(res.data.message)
            })
    }
</script>
